<div class="tool-tip" role="tooltip" @tooltip>
  <div class="arrow"></div>
  <div class="tooltip-inner" [innerHTML]="text"></div>
</div>
